import header from 'marketing-website/media/images/pages/marvel-vs-zeplin/Header2x.jpg';
import designsIntoCode from 'marketing-website/media/images/pages/marvel-vs-zeplin/DesignsIntoCode2x.jpg';
import handoffPrototyping from 'marketing-website/media/images/pages/marvel-vs-zeplin/HandoffPrototyping2x.jpg';
import publicShare from 'marketing-website/media/images/pages/marvel-vs-zeplin/PublicShare2x.jpg';
import symbolSync from 'marketing-website/media/images/pages/marvel-vs-zeplin/SymbolSync2x.jpg';
import userTesting from 'marketing-website/media/images/pages/marvel-vs-zeplin/UserTesting2x.jpg';

const assets = {
  header: {
    src: header,
    maxWidth: 1000,
  },
  designsIntoCode: {
    alt: 'turning designs into code',
    src: designsIntoCode,
    maxWidth: 800,
  },
  handoffPrototyping: {
    alt: 'handoff preview',
    src: handoffPrototyping,
    maxWidth: 800,
  },
  publicShare: {
    alt: 'share screen preview',
    src: publicShare,
    maxWidth: 800,
  },
  symbolSync: {
    alt: 'syncing symbols preview',
    src: symbolSync,
    maxWidth: 800,
  },
  userTesting: {
    alt: 'preview of user testing',
    src: userTesting,
    maxWidth: 800,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/marvel-vs-zeplin/assets.js